import axios from "axios";
import route from "ziggy-js";

export const useDevice = () => {
    const updateDevice = async (
        deviceId,
        deviceToken,
        notificationPermission
    ) => {
        try {
            await axios.post(route("api.devices.store"), {
                device_id: deviceId,
                device_token: deviceToken,
                notification_permission: notificationPermission,
            });

            // Keep the deviceId in localStorage until a user logs out.
            // This is needed to know the current device a user is on when logging them out.
            localStorage.setItem("deviceId", deviceId);
        } catch (error) {
            if (error.response.status !== 409) {
                throw error;
            }
        }
    };

    const logoutDevice = async () => {
        try {
            const deviceId = localStorage.getItem("deviceId");
            await axios.delete(route("api.devices.destroy", deviceId));

            // When a user logs out of their device, the deviceId is no longer needed.
            localStorage.removeItem("deviceId");
        } catch (error) {
            if (error.response.status !== 404) {
                throw error;
            }
        }
    };

    return {
        updateDevice,
        logoutDevice,
    };
};
